import { Component } from '@angular/core'

@Component({
  selector: 'app-fee-schedule',
  templateUrl: './fee-schedule.component.html',
  standalone: false
})
export class FeeScheduleComponent {}
